var React = require('react');

function UserCrown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M352 96H96V0l64 32 64-32 64 32 64-32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M313.6 304h-16.71a174 174 0 0 1-145.78 0H134.4A134.4 134.4 0 0 0 0 438.4V464a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48v-25.6A134.4 134.4 0 0 0 313.6 304zM224 272a128 128 0 0 0 128-128v-16H96v16a128 128 0 0 0 128 128z","className":"fa-primary","key":2})]);
}

UserCrown.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = UserCrown;

UserCrown.default = UserCrown;
